const sageThumbs = [...document.querySelectorAll('.sage-kit-page .pdp-thumb')];
const sageMainPhoto = document.querySelector('#sage-main-photo');
let sagePhotoIndex = 0;
let sagePhotoRequest = 0;

function showSagePhoto(index) {
  sagePhotoIndex = (index + sageThumbs.length) % sageThumbs.length;
  const thumb = sageThumbs[sagePhotoIndex];
  const src = thumb.dataset.src;
  const request = ++sagePhotoRequest;
  sageMainPhoto.classList.add('is-changing');
  const preload = new Image();
  let revealed = false;
  const reveal = () => {
    if (revealed || request !== sagePhotoRequest) return;
    revealed = true;
    (window.BasicProductImages ? window.BasicProductImages.setImage(sageMainPhoto, src) : (sageMainPhoto.removeAttribute('srcset'), sageMainPhoto.src = src));
    sageMainPhoto.alt = thumb.dataset.alt;
    sageMainPhoto.classList.toggle('is-packshot', sagePhotoIndex === 0);
    sageThumbs.forEach((button, buttonIndex) => {
      const active = buttonIndex === sagePhotoIndex;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    requestAnimationFrame(() => sageMainPhoto.classList.remove('is-changing'));
  };
  preload.onload = reveal;
  preload.onerror = reveal;
  (window.BasicProductImages ? window.BasicProductImages.setImage(preload, src, sageMainPhoto) : (preload.removeAttribute('srcset'), preload.src = src));
  if (preload.complete) reveal();
}

sageThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSagePhoto(index)));
document.querySelector('#sage-photo-prev')?.addEventListener('click', () => showSagePhoto(sagePhotoIndex - 1));
document.querySelector('#sage-photo-next')?.addEventListener('click', () => showSagePhoto(sagePhotoIndex + 1));

const sagePurchase = document.querySelector('#sage-cart-form');
const sageMobileBuy = document.querySelector('#sage-mobile-buy');
if (sagePurchase && sageMobileBuy) {
  const syncSageMobileBuy = () => {
    const pastPurchase = sagePurchase.getBoundingClientRect().bottom < 75;
    sageMobileBuy.classList.toggle('is-visible', window.innerWidth <= 700 && pastPurchase);
  };
  window.addEventListener('scroll', syncSageMobileBuy, {passive:true});
  window.addEventListener('resize', syncSageMobileBuy);
  syncSageMobileBuy();
}
